/**
 * ピンチインアウトの抑制
 *
 * HACK: iOSで viewport の user-scalable=no が無視されるようになったことに対するハック
 * @see https://webinlet.com/2020/ios11以降でピンチインアウト拡大縮小禁止
 *
 * CAUTION: アクセシビリティを損なう（が、「アプリらしさ」を優先する）
 */
document.body.addEventListener(
  'touchstart',
  (e) => {
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
    }
  },
  { passive: false }
);
document.body.addEventListener(
  'touchmove',
  (e) => {
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
    }
  },
  { passive: false }
);
